import ApiService from './service';
import * as http from './http';
import { stringify } from 'query-string';

export class CertificationService extends ApiService {

    async getList(request) {
            const { limit, currentPage, search, sort, filter, user } = request;
            const query = {
                search,
    
                limit,
                sort: JSON.stringify(sort),
                filter: JSON.stringify(filter),
                page: currentPage,
                user,
            };
    
            if (!search) {
                delete query.search;
            }
            const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;
            const response = await http
                .get(url, this.store)
                .catch((err) => console.log(err));
            return { data: response.data };
        }
    
    async getDetails(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return response;
        } catch (err) {
            return { data: {} };
        }
    }
    async getDetailsByEmail(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return response;
        } catch (err) {
            return { data: {} };
        }
    }

    async addDetails(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }

    async updateDetails(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.put(url, data, this.store);
    }

    async deleteRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.remove(url, this.store);
    }

    async softDeleteRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const data = {};
        return http.patch(url, data, this.store);
    }
}
